module.exports = __webpack_public_path__ + "assets/d9659a7bfec996a85675d98a697150f2.jpeg";